import { randomUUID } from '@shared/utils';

import type { QBSLevelItemExcludingTag } from '../types';

import { findLastOrderBySiblings } from './order';

export function duplicateQBankStructureLevelItems(
  targetLevelItemId: string,
  levelItems: QBSLevelItemExcludingTag[],
) {
  const duplicatedLevelItems: QBSLevelItemExcludingTag[] = [];

  const targetLevelItem = levelItems.find((item) => {
    return item.id === targetLevelItemId;
  });

  const duplicatedIds = new Map<string, string | null>();

  if (!targetLevelItem) {
    return { duplicatedLevelItems: null, duplicatedIds };
  }

  const newOrder = findLastOrderBySiblings(levelItems, targetLevelItem.parentLevelItemId) + 1;

  const parentIdsMap = new Map<string, string>();
  const id = randomUUID();
  parentIdsMap.set(targetLevelItem.id, id);

  const queue: string[] = [targetLevelItemId];

  duplicatedLevelItems.push({
    ...targetLevelItem,
    id,
    order: newOrder,
    isNew: true,
  });

  duplicatedIds.set(targetLevelItem.id, id);
  while (queue.length > 0) {
    const levelItem = queue.shift();
    const children = levelItems.filter((item) => item.parentLevelItemId === levelItem);

    for (const child of children) {
      queue.push(child.id);

      const parentLevelItemId =
        child.parentLevelItemId && parentIdsMap.get(child.parentLevelItemId);

      if (parentLevelItemId) {
        const id = randomUUID();
        duplicatedLevelItems.push({
          ...child,
          parentLevelItemId,
          id,
          isNew: true,
        });
        duplicatedIds.set(child.id, id);
        parentIdsMap.set(child.id, id);
      }
    }
  }

  return { duplicatedLevelItems, duplicatedIds };
}
